import { isSumaho } from '../common/isSumaho';

require('slick-carousel');

export function grsl() {
  $('.gr-sl').each(function () {
    const sl = $(this);
    const nav = sl.clone().removeClass('gr-sl').addClass('gr-nav');
    if (isSumaho()) {
      sl.after(nav);
    } else {
      sl.next('figcaption').append(nav);
    }
    sl.slick({
      asNavFor: nav,
      arrows: false,
    });
    nav.slick({
      slidesToShow: 5,
      arrows: false,
      focusOnSelect: true,
      asNavFor: sl,
      variableWidth: false,
    });
  });
}
